import _ from 'lodash';

function Ctrl($scope,
  $q,
  venueService, $state, organizationMemberService, managementUserService, organizationService, alertService, ERROR_MESSAGES, sdkUtils, loggerService, modalService, organizationIntegrationService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.loading = false;

  $scope.integrationTypes = [
    //   {
    //   type: 'BITLY',
    //   name: 'Bitly'
    // },
    {
      type: 'INSIGHTLY',
      name: 'Insightly'
    }, {
      type: 'MAILCHIMP',
      name: 'Mailchimp'
    }, {
      type: 'POS',
      name: 'Point of Sale'
    }
    // {
    //   type: 'YELP',
    //   name: 'Yelp'
    // }
  ];

  $scope.integrations = [];

  $scope.addIntegration = function(integrationType, venue) {
    const integration = _.find($scope.integrations, {
      type: integrationType.type,
      venue: venue.id
    });

    modalService.addIntegration({
        integrationType,
        integration,
        venue
      })
      .then(result => {
        if (!result) return;

        if (result.new) {
          $scope.integrations.push(result.integration);
        } else {
          const updatedIntegration = _.find($scope.integrations, {
            id: result.integration.id
          });

          _.extend(updatedIntegration, result.integration);
        }

        alertService.success(result.integration.status === 'ACTIVE' ? 'Integration enabled' : 'Integration disabled');
      })
      .catch(() => {
        alertService.error('There was an error enabling the integration');
      });
  };

  $scope.getIntegrationImage = function(integrationType) {
    if (integrationType.type === 'BITLY') return 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro/bilty.png';
    if (integrationType.type === 'INSIGHTLY') return 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro/insightly.png';
    if (integrationType.type === 'MAILCHIMP') return 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro/mailchimp.png';
    if (integrationType.type === 'POS') return 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro/pos-selected%402x.png';
    if (integrationType.type === 'YELP') return 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro/yelp.png';

    return '';
  };

  $scope.getVenueIntegrations = function(venue) {
    return $scope.integrationTypes.map(integrationType => {
      integrationType.logo = $scope.getIntegrationImage(integrationType);
      integrationType.active = !!(_.find($scope.integrations, {
        type: integrationType.type,
        venue: venue.id,
        status: 'ACTIVE'
      }));

      return integrationType;
    });
  };

  $scope.loading = true;

  $q.all([
      venueService.getCurrentVenues(),
      organizationIntegrationService.listByOrganizationId(currentUserOrganization.id)
    ])
    .then(results => {
      $scope.venues = results[0];
      $scope.integrations = results[1].data;

      // $scope.mapIntegrationsToIntegrationTypes();

      $scope.loading = false;
    })
    .catch(() => {
      $scope.loading = false;

      alertService.error('There was an error loading your integrations');
    });
}

Ctrl.$inject = [
  '$scope',
  '$q',
  'venueService',
  '$state',
  'jsSdk.organizationMember',
  'jsSdk.managementUser',
  'organizationService',
  'alertService',
  'ERROR_MESSAGES',
  'jsSdk.utils',
  'loggerService',
  'modalService',
  'jsSdk.organizationIntegration'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/settingsIntegrations/settingsIntegrationsCtrl.js